import { useNavigate } from 'react-router-dom';
import * as Assets from '../../utils/svg_assets';
import './style.scss';

const Header = (props) => {
  const navigate = useNavigate();
  const {
    page,
    isBack = true,
    toPath,
    bgImg = `${process.env.PUBLIC_URL + '/SKORE-Header-Bg.png'}`,
    handleClick = () => {},
    isFlex = false,
    content = '',
  } = props;

  return (
    <div
      className="header"
      onClick={handleClick}
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {isBack ? (
        <div className="p-3" onClick={() => navigate(toPath)}>
          <img src={Assets.iconBackWhite} alt="iconArrowLeft" />
        </div>
      ) : (
        ''
      )}

      {isFlex ? content : <div className="label">{page}</div>}
    </div>
  );
};

export default Header;
